import { render, staticRenderFns } from "./FormCreateEdit.vue?vue&type=template&id=49790846"
import script from "./FormCreateEdit.vue?vue&type=script&lang=js"
export * from "./FormCreateEdit.vue?vue&type=script&lang=js"
import style0 from "./FormCreateEdit.vue?vue&type=style&index=0&id=49790846&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports